<template>
  <div class="online-container">
    <img
      v-if="advertisements.filter(a => a.category.id == 8).length > 0"
      :src="advertisements.filter(a => a.category.id == 8)[0].picture"
      style="width: 100%; height: 350px"
      @click="
        handleAdvertisementClick(
          advertisements.filter(a => a.category.id == 8)[0]
        )
      "
    />
    <img
      v-else
      src="../assets/images/slide1.png"
      style="width: 100%; height: 350px"
    />
    <div class="container">
      <div class="online-header row" v-if="!filters.name">
        <!-- <div class="exten_pub">
          <img
            class="exten_pub_img"
            style="width: 101px; height: 101px"
            src="../assets/images/exten_pub.png"
          />
          <img
            style="width: 372px; height: 379px"
            src="../assets/images/pavilion.png"
          />
        </div> -->
        <div class="online-header-list">
          <div
            v-for="(item, idx) in venues"
            :key="idx"
            :class="[
              'online-header-item',
              { onlineActive: filters.venueId == item.id }
            ]"
            @click="handleItemClick(item)"
          >
            <div class="online-header-img">
              <img :src="item.icon" />
            </div>
            <!-- <div> -->
            <p class="header-position-code">
              {{ item.number }}
            </p>
            <p
              class="online-header-text"
              style="width: 90%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;"
            >
              {{ $i18n.locale == "zh" ? item.name : item.nameEn }}
            </p>
            <!-- </div> -->
          </div>
        </div>
      </div>
      <div class="row-between" style="padding: 30px 0" v-if="!filters.name">
        <div class="row">
          <div class="row online-sort">
            <el-radio-group
              fill="#619A37"
              style="margin-right: 20px"
              v-model="sorter.field"
              size="mini"
              @change="handleParamChange"
            >
              <el-radio-button
                v-for="sort in sorters"
                :label="sort.value"
                :key="sort.value"
                >{{ sort.lable }}</el-radio-button
              >
            </el-radio-group>
          </div>
        </div>
        <p class="checkall" @click="handleClickAll">{{ $t("All Company") }}</p>
      </div>
      <div>
        <div class="online-list">
          <div
            v-for="(item, idx) in entities"
            :key="idx"
            class="online-item row-between"
            @click="goDetail(item)"
          >
            <div class="online-item-bg row-center">
              <img
                class="online-icon-recom"
                :src="
                  (item.properties && item.properties.coverImage) ||
                    require('../assets/images/icon_1.png')
                "
              />
            </div>
            <div class="online-item-top">
              <div class="online-item-img">
                <div style="width: 131px; height: 31px">
                  <img
                    style="max-height: 100%; max-width: 100%"
                    :src="
                      (item.properties && item.properties.logo) ||
                        require('../assets/images/icon_2.png')
                    "
                  />
                </div>
                <img
                  v-if="item.liked"
                  class="online-icon-star"
                  src="../assets/images/icon_star.png"
                  @click.stop="handleLikeClick('EXHIBITOR', item.id, true)"
                />
                <img
                  v-else
                  class="online-icon-star"
                  src="../assets/images/icon_unstar.png"
                  @click.stop="handleLikeClick('EXHIBITOR', item.id, false)"
                />
              </div>
              <p class="online-item-comp">
                {{ $i18n.locale == "zh" ? item.name : item.nameEn }}
              </p>
              <p class="online-item-position">
                {{ $t("Hall") }}：{{
                  $i18n.locale == "zh" ? item.venueName : item.venueNameEn
                }}
              </p>
              <p class="online-item-range">
                {{ $t("Business Content") }}：{{
                  $i18n.locale == "zh"
                    ? item.businessScope
                    : item.businessScopeEn
                }}
              </p>
              <div class="online-btn-list row-between">
                <p
                  v-if="false"
                  @click.stop="handleContactClick(item)"
                  :style="$i18n.locale == 'zh' ? '' : ';'"
                >
                  {{ $t("Send Massage") }}
                </p>
                <p
                  @click.stop="handleAppointmentClick(item)"
                  :style="$i18n.locale == 'zh' ? '' : ';'"
                >
                  {{ $t("Reservation") }}
                </p>
                <p
                  v-if="item.collected"
                  :style="
                    $i18n.locale == 'zh'
                      ? 'background: #999999; color: #ffffff'
                      : 'background: #999999; color: #ffffff; ;'
                  "
                  @click.stop="handleCollectClick('EXHIBITOR', item.id, true)"
                >
                  {{ $t("Favorited") }}
                </p>
                <p
                  v-else
                  :style="$i18n.locale == 'zh' ? '' : ';'"
                  @click.stop="handleCollectClick('EXHIBITOR', item.id, false)"
                >
                  {{ $t("Favorite") }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <el-pagination
          style="text-align: center; padding-bottom: 30px"
          background
          layout="prev, pager, next"
          :current-page="pagination.current"
          :page-size.sync="pagination.pageSize"
          :total="pagination.total"
          @current-change="handlePageChange"
        >
        </el-pagination>
      </div>
    </div>
    <Dialoglist
      v-if="dialogFormVisible"
      :key="dialogFormVisible"
      :exhibitid="exhibitid"
      :dialogtype="'contactbusiness'"
      :dialogFormVisible="dialogFormVisible"
      @handleCloseDialog="handleCloseDialog"
    />
    <Dialoglist
      v-if="reservedialogFormVisible"
      :key="reservedialogFormVisible"
      :exhibitid="exhibitid"
      :dialogtype="'reserve'"
      :dialogFormVisible="reservedialogFormVisible"
      @handleCloseDialog="is => (reservedialogFormVisible = is)"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import { EventBus } from "../EventBus";
import ExhibitorService from "../services/exhibitor";

import Dialoglist from "@/components/dialoglist";
import {
  getBusinessZoneBanners,
  getVenue,
  getExhibitorPageList
} from "../http/api";
export default {
  components: { Dialoglist },
  data() {
    return {
      advertisements: [],
      // 排序
      sorters: [
        {
          lable: this.$t("Default"),
          value: "sequence"
        },
        {
          lable: this.$t("Latest"),
          value: "create_time"
        }
      ],
      // 数据服务
      service: ExhibitorService,
      // 初始参数绑定
      entity: {
        enabled: true,
        approved: true,
        approveResult: "APPROVED"
      },
      // 查询参数绑定
      filters: {
        venueId: null
      },
      // 查询排序参数绑定
      sorter: {
        field: "sequence",
        order: "DESC"
      },
      // 页面数据
      entities: [],
      // 展馆
      venues: [],
      // 分页参数
      pagination: {
        current: 1,
        pageSize: 12,
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      exhibitid: "",
      dialogFormVisible: false,
      reservedialogFormVisible: false
    };
  },
  computed: {
    // ...mapState({
    //   venues: state => state.venues
    // }),
    ...mapGetters({
      hasAuthentication: "hasAuthentication",
      hasCollected: "hasCollected",
      hasLiked: "hasLiked"
    })
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        window.scrollTo(0, 0);

        this.filters.language = this.$i18n.locale == "zh" ? "ZH" : "EN";

        if (this.$route.query["venue.id"]) {
          this.filters.venueId = this.$route.query["venue.id"];
        }

        if (this.$route.query["key"]) {
          this.filters.name = this.$route.query["key"];
          this.filters.name = this.$route.query["key"];
        }

        this.handleParamChange();
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      addCollected: "addCollected",
      deleteCollected: "deleteCollected",
      addLiked: "addLiked",
      deleteLiked: "deleteLiked"
    }),
    setexhibitid(id) {
      this.dialogFormVisible = true;
      this.exhibitid = id;
    },
    handleCloseDialog(is) {
      this.dialogFormVisible = is;
    },
    goDetail({ id }) {
      this.$router.push({
        name: "companyIntroduction",
        query: {
          id: id
        }
      });
    },
    // -------------------------------------------------------------------------------------------------
    async handleAdvertisementClick(advertisement) {
      if (advertisement.type == "BANNER" && advertisement.link) {
        window.open(advertisement.link);
      }
    },
    // 联系点击事件
    handleContactClick(exhibit) {
      if (!this.hasAuthentication()) {
        this.$router.push("/login");
        return;
      }

      this.exhibitid = exhibit.id;
      this.dialogFormVisible = true;
    },
    // 预约点击事件
    handleAppointmentClick(exhibit) {
      if (!this.hasAuthentication()) {
        this.$router.push("/login");
        return;
      }

      this.exhibitid = exhibit.id;
      this.reservedialogFormVisible = true;
    },
    async handleCollectClick(type, id, status) {
      if (status) {
        // 已经收藏
        await this.deleteCollected({
          type: type,
          id: id
        });
      } else {
        //收藏
        await this.addCollected({
          type: type,
          id: id
        });
      }
    },
    async handleLikeClick(type, id, status) {
      if (status) {
        // 已经收藏
        await this.deleteLiked({
          type: type,
          id: id
        });
      } else {
        //收藏
        await this.addLiked({
          type: type,
          id: id
        });
      }
    },
    async handleItemClick({ id }) {
      this.filters.venueId = id;
      this.handleParamChange();
    },
    handleClickAll() {
      this.filters.venueId = null;
      this.handleParamChange();
    },
    handleParamChange() {
      this.pagination.current = 1;
      this.getEntityPage(
        this.entity,
        this.pagination,
        this.filters,
        this.sorter
      );
    },
    handlePageChange(page) {
      this.pagination.current = page;
      this.getEntityPage(
        this.entity,
        this.pagination,
        this.filters,
        this.sorter
      );
    },
    async getAdvertisements() {
      this.advertisements = await getBusinessZoneBanners();

      this.advertisements = this.advertisements.map(advertisement => {
        if (advertisement.exhibit) {
          advertisement.exhibit.liked = this.hasLiked(
            "EXHIBIT",
            advertisement.exhibit.id
          );

          advertisement.exhibit.collected = this.hasCollected(
            "EXHIBIT",
            advertisement.exhibit.id
          );
        }

        if (advertisement.exhibitor) {
          advertisement.exhibitor.liked = this.hasLiked(
            "EXHIBITOR",
            advertisement.exhibitor.id
          );

          advertisement.exhibitor.collected = this.hasCollected(
            "EXHIBITOR",
            advertisement.exhibitor.id
          );
        }

        return advertisement;
      });
    },

    async getVenues() {
      const result = await getVenue();
      // this.venues = result.slice(0, 11);
      // this.venues = [...firstFive];
      const list = [...result];
      list.push({
        id: "",
        number: "",
        name: "全部展馆",
        nameEn: "ALL",
        icon: require("../assets/images/online_bicycle12.png")
      });
      // list.splice(5, 0, {
      //   id: "",
      //   number: "",
      //   name: "全部展馆",
      //   nameEn: "ALL",
      //   icon: require("../assets/images/online_bicycle12.png")
      // });
      this.venues = [...list];
    },

    async getEntityPage(entity, pagination, filters, sorter) {
      if (filters) {
        for (const key in filters) {
          const param = filters[key];
          entity[key] = param;
        }
      }

      const pageable = {
        page: pagination.current - 1,
        size: pagination.pageSize
      };

      if (sorter) {
        pageable.sort = `${sorter.field} ${
          sorter.order ? sorter.order : "DESC"
        }, id DESC`;
      }
      const result = await getExhibitorPageList(
        {
          ...entity,
          isUp: true
        },
        pageable
      );

      this.entities = result.content;
      this.entities = this.entities.map(exhibitor => {
        exhibitor.liked = this.hasLiked("EXHIBITOR", exhibitor.id);
        exhibitor.collected = this.hasCollected("EXHIBITOR", exhibitor.id);
        return exhibitor;
      });
      this.pagination.current = result.number + 1;
      this.pagination.total = result.totalElements;
    }
  },
  async mounted() {
    this.getAdvertisements();

    this.filters.language = this.$i18n.locale == "zh" ? "ZH" : "EN";

    if (this.$route.query["venue.id"]) {
      this.filters.venueId = this.$route.query["venue.id"];
    }

    if (this.$route.query["key"]) {
      this.filters.name = this.$route.query["key"];
    }

    this.getEntityPage(this.entity, this.pagination, this.filters, this.sorter);

    this.getVenues();

    EventBus.$on("setLiked", () => {
      this.entities = this.entities.map(exhibitor => {
        exhibitor.liked = this.hasLiked("EXHIBITOR", exhibitor.id);
        return exhibitor;
      });
    });

    EventBus.$on("setCollected", () => {
      this.entities = this.entities.map(exhibitor => {
        exhibitor.collected = this.hasCollected("EXHIBITOR", exhibitor.id);
        return exhibitor;
      });
    });
  }
};
</script>
<style lang="less" scoped>
.online-container {
  background: #eaeaea;
  .container {
    width: 1200px;
    margin: 0 auto;
  }
}

.online-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
.online-item:hover .online-item-comp {
  // background: #619A37;
  // color: #FFFFFF;
}
.online-item {
  width: 585px;
  height: 270px;
  background: #fff;
  margin-bottom: 30px;
  cursor: pointer;
  .online-item-top {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    flex: 1;
    padding: 20px 24px;
    box-sizing: border-box;
    .online-item-img {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .online-icon-logo {
        width: 131px;
        height: 31px;
      }
    }
    .online-icon-star {
      width: 13px;
      height: 14px;
    }
    .online-item-name {
      width: 100%;
      font-size: 14px;
      font-family: FZLanTingHeiS-DB1-GBK;
      font-weight: 400;
      color: #444444;
      text-align: center;
      padding: 18px 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .online-item-comp {
    width: 100%;
    font-size: 18px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #444444;
    height: 46px;
    width: 281px;
    line-height: 46px;
    border-bottom: 1px solid #dddddd;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    // overflow: hidden;
    // white-space: nowrap;
    // text-overflow: ellipsis;
  }
  .online-item-position,
  .online-item-range {
    font-size: 14px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #666666;
    line-height: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 280px;
    // width: 300px;
  }
}
.online-sort-title {
  font-size: 14px;
  font-family: FZLanTingHeiS-DB1-GBK;
  font-weight: 400;
  color: #444444;
}
.exten_pub {
  width: 470px;
  height: 398px;
  background: #ffffff;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.exten_pub_img {
  position: absolute;
  top: 0;
  left: 0;
}
.online-header-list {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 398px;
  flex-wrap: wrap;
  margin-top: 20px;
  background-color: #333333;
  .online-header-item {
    // width: 121px;
    width: 100% / 7;
    height: 199px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #333333;
    cursor: pointer;
    .online-header-img {
      width: 120px;
      height: 76px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        height: 56px;
      }
    }
    .online-header-text {
      text-align: center;
      font-size: 14px;
      font-family: FZLanTingHeiS-DB1-GBK;
      font-weight: 400;
      color: #ffffff;
    }
    .header-position-code {
      font-size: 28px;
      font-family: FZLanTingHeiS-DB1-GBK;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
.online-header-item:hover,
.online-header-list .onlineActive {
  background: #619a37;
}
/deep/ .online-swiper .el-carousel__container {
  height: 399px !important;
  width: 572px;
}
.online-header-swiper {
  margin-top: 40px;
  background: #ffffff;
}
.online-siper-detail {
  padding: 100px 15px 30px 15px;
  height: 100%;
  box-sizing: border-box;
  .online-siper-name {
    font-size: 14px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #444444;
  }
  .online-siper-comp {
    font-size: 14px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #999999;
    margin-top: 16px;
    margin-bottom: 14px;
  }
  .online-siper-btnlist {
    p {
      width: 58px;
      height: 30px;
      background: #619a37;
      border-radius: 2px;
      line-height: 30px;
      text-align: center;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      margin-right: 4px;
    }
  }
  .online-swiper-line {
    width: 100px;
    height: 1px;
    background: #999999;
    margin: 20px 0;
  }
  .online-siper-desc {
    font-size: 12px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #666666;
  }
}
.online-header-left {
  height: 100%;
  .online-header-tag {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    .online-icon-new {
      width: 50px;
      height: 38px;
      margin-top: 20px;
    }
  }
  .online-swiper-img {
    margin: -8px 0 0 10px;
  }
}
.online-item-bg {
  width: 256px;
  height: 256px;
  padding: 6px;
  .online-icon-recom {
    max-width: 100%;
    max-height: 100%;
  }
}
.online-btn-list p {
  background: #ffffff;
  border: 1px solid #dddddd;
  color: #999999;
  text-align: center;
  padding: 17px 0;
  font-size: 14px;
  font-family: FZLanTingHeiS-DB1-GBK;
  font-weight: 400;
  width: 64px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.online-btn-list p:first-child {
  padding: 17px 0;
  background: #619a37;
  color: #ffffff;
  width: 134px;
}
.checkall {
  font-size: 14px;
  font-family: FZLanTingHeiS-DB1-GBK;
  font-weight: 400;
  color: #444444;
  padding: 8px 24px;
  background: #ffffff;
  border: 1px solid #dddddd;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/business.vue